<template>
  <div class="option" :class="{ active: isActive }"  @click="$emit('click')">
    <p class="recommend-badge" :class="{ 'not-recommended': !isRecommended }">
      <span  v-if="isRecommended">Most Popular</span>
    </p>
    <div class="option-heading">
      <span class="checkmark" :class="{ active: isActive }"></span>
      <div>{{title}}</div>
    </div>
    <div class="content" v-html="option.description"/>
  </div>
</template>
<script>
export default {
  name: "TextOptionCard",
  props: {
    isActive: Boolean,
    option: Object,
    isRecommended: Boolean,
  },
  computed: {
    title() {
      const packageIndex = this.option.title.toLowerCase().indexOf('package')
      if (packageIndex < 0) return this.option.title

      return this.option.title.slice(0, packageIndex)
    }
  }
};
</script>
<style scoped>
.not-more-than-one .recommend-badge {
  min-height: unset!important;
  margin-bottom: 0;
  margin-top: 7px;
}
.recommend-badge {
  background-color: #7E8772;
  color: #FFF;
  text-align: center;
  font-family: var(--oddit-main-font);
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 140%; /* 19.6px */
  text-transform: uppercase; 
  margin: 14px 14px 5px;
  margin-left: 0;
  border-radius: 0 5px 5px 0;
  min-height: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.recommend-badge.not-recommended {
  opacity: 0;
}
.option-heading {
  display: flex;
  align-items: center;
  gap: 8px;
  font-weight: 500;
  font-size: 14px;
  line-height: 140%;  
  padding: 0 6px;
  /* justify-content: center; */
}
.checkmark {
  height: 14px;
  width: 14px;
  background-color: #fff;
  border-radius: 50%;
  border: 1px solid #ccc;
  position: relative;
  /* margin-right: 5px; */
  flex-shrink: 0;
}
.checkmark::after {
  top: 3px;
  left: 3px;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  transition: 0.2s ease-in-out;
  background: #3a3830;
  content: "";
  position: absolute;
  opacity: 0;
}
.checkmark.active::after {
  opacity: 1;
}

.content {
  font-weight: 400;
  font-size: 12px;
  line-height: 140%;
  text-align: left;
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 6px;
}
.option {
  display: flex;
  flex-direction: column;
  /* justify-content: space-between; */
  width: 50%;
  border: 1px solid #dfdcd7;
  border-radius: 6px;
  margin: 5px;
  cursor: pointer;
}
.option.active {
  background: #F0F0F0;
  border: 1px solid rgba(0, 0, 0, 0.1);
}
@media screen and (min-width: 1280px) {
  .option {
    align-items: unset;
  }
}
@media screen and (min-width: 1024px) {
  .not-more-than-one .recommend-badge {
    margin-top: 14px;
  }
  .content {
    font-size: 13px;
    padding-left: 13px;
    padding-right: 13px;
    padding-bottom: 14px;
  }
  .option-heading {
    font-size: 16px;
    padding: 0 12px;
  }
  .recommend-badge {
    min-height: 31px;
    margin-right: 40px;
  }
  
  .recommend-badge {
    margin-bottom: 7px;
  }
}
</style>
